<template>
  <div>
    <back :title="titlename"></back>
    <!-- 预约办 -->
    <van-form @submit="onSubmit">
      <van-field v-model.trim="name" name="姓名" label="姓名" placeholder="请填写" />
      <van-field readonly clickable name="picker" :value="sqvalue"  label="所属社区" placeholder="请选择" @click="showPicker1 = true" />
      <!-- <van-field readonly clickable name="picker" :value="value" label="预约网络点" placeholder="请选择" @click="showPicker = true" /> -->
      <van-field v-model.trim="phone" type="number" name="联系电话" label="联系电话" placeholder="请填写" />
      <div class="textarea">
        <p>办理事项具体说明</p>
        <textarea v-model="content" name="" id="" placeholder="请填写"></textarea>
      </div>
      <van-field v-model.trim="address" type="text" name="具体地址" label="具体地址" placeholder="请填写" />
      <van-field readonly clickable name="pickertime" :value="time" label="预约办理日期" placeholder="请选择" @click="showtime = true" />
      <van-field readonly clickable name="pickertime" :value="hour" label="预约办理时间" placeholder="请选择" @click="showhour = true" />
      <van-field readonly clickable name="" :value="cjinfo" label="上门理由" placeholder="请选择" @click="cjshow = true" />
      <div class="upload" v-if="uploadshow">
        <van-uploader v-model="uploader" :max-count="1"/>
        <p>请上传证明<br>格式支持PNG、pdf、jpg</p>
      </div>

      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
      <!-- 预约社区下拉框选项 -->
      <van-popup v-model="showPicker1" position="bottom">
        <van-picker show-toolbar :columns="districtList" value-key="name" @confirm="onConfirm1" @cancel="showPicker1 = false" />
      </van-popup>

      <!-- 预约网络点下拉框选项 -->
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar :columns="columns" value-key="name" @confirm="onConfirm" @cancel="showPicker = false" />
      </van-popup>
      <!-- 时间下拉 -->
      <van-popup v-model="showtime" position="bottom">
        <van-datetime-picker :min-date="minDate" :max-date="maxDate" type="date" @confirm="onConfirmtime" @cancel="showtime = false" />
      </van-popup>
      <!-- 是否有残疾 -->
      <van-popup v-model="cjshow" position="bottom">
        <van-picker show-toolbar :columns="cjinfolist" @confirm="cjinfoshow" @cancel="cjshow = false" />
      </van-popup>
    </van-form>
    <van-popup v-model="showhour" position="bottom">
        <van-picker title="选择时间" show-toolbar :columns="timelist" @confirm="onConfirmhour" @cancel="showhour=false" />
      </van-popup>
    </van-form>
  </div>

</template>

<script>
  import { Form,Toast } from 'vant'
  import $ from 'jquery'
  export default {
    data() {
      return {
        titlename: "上门办",
        name:"",
        phone:"",
        value: '',
        columns: [],
        showPicker: false,
        time:"",
        showtime: false,
        content:"",
        minDate: new Date(),
        maxDate: new Date(),
        address:"",
        cjshow:false,
        cjinfolist:['残疾','老人','孕妇','其他'],
        cjinfo:"",
        uploader:[],
        uploadshow:true,
        sqvalue:"",
        showPicker1: false,
        sqid:"",
        wgid:"",
        districtList:"",
        hour:"",
        showhour:false,
        timelist:["8:30","9:00","9:30","10:00","10:30","11:00","11:30","12:00","12:30","13:00","13:30","14:00","14:30","15:00","15:30","16:30"]
      };
    },
    created:function(){
      this.getperinfo()
      this.getList(1)
      var date=new Date()
      this.minDate=new Date(date.getFullYear(),date.getMonth(),date.getDate()+1)
      this.maxDate=new Date(date.getFullYear(),date.getMonth(),date.getDate()+5)
    },
    methods: {
      // 获取个人信息
      getperinfo(){
        this.$http.post(this.$store.state.host+"/interface/getUser",{openid:this.$store.state.openId},{emulateJSON:true})
        .then(res=>{
          //发送成功
          console.log(res)
          if(res.body.code==0){
            this.name=res.body.userPd.realname
            this.phone=res.body.userPd.phone
          }

          //if()
        },res=>{
           //发送失败
        })
      },
      // 获取社区 1.社区
      getList(obj){
        this.$http.post(this.$store.state.host+"/interface/districtList",{DISTRICT_ID:obj},{emulateJSON:true})
        .then(res=>{
          //发送成功
          console.log(res)
          if(res.body.code==0){
            if(obj==1){
              this.districtList=res.body.list
            }
            else{
              this.columns=res.body.list
            }
          }
        },res=>{
           //发送失败
        })
      },
      //社区赋值
      onConfirm1(value) {
        this.sqvalue = value.name;
        this.sqid=value.district_ID
        console.log(this.sqid)
        this.showPicker1 = false;
        this.getList(value.district_ID)
        this.value=""//清空网格名称
        this.wgid=""//清空网格id
      },
      //预约网点赋值
      onConfirm(value) {
        console.log(value)
        this.value = value.name;
        this.wgid=value.district_ID
        this.showPicker = false;
      },
      //时间赋值
      onConfirmtime(value) {
        //var time = new Date()
        var year = value.getFullYear()//年
        var month = value.getMonth() + 1//月
        month=month>9?month:'0'+month//小于10加前缀0
        var day = value.getDate()
        day=day>9?day:'0'+day//小于10加前缀0
        let hour=value.getHours()
        hour=hour>9?hour:'0'+hour
        let minute=value.getMinutes()
        minute=minute>9?minute:'0'+minute
        var week=value.getDay()
        if(week==0||week==6){
          Toast("该日期为周六、周日不可选，请重新选择！")
          return false
        }
        this.time = year+'-'+month+'-'+day//+' '+hour+':'+minute
        console.log(value)
        this.showtime = false;
      },
      onConfirmhour(value){
        this.hour=value
        this.showhour=false
      },
      //是否有残疾赋值
      cjinfoshow(value,index){
        this.cjinfo=value
        this.cjshow=false
        // if(this.cjinfo=="是"){
        //   this.uploadshow=true
        // }
        // else{
        //   this.uploadshow=false
        //   this.uploader=[]
        // }
      },
      // 提交
      onSubmit(){

        Toast.loading({
          message: '提交中...',
          forbidClick: true,
          duration:0
        });
        if(this.name==""||this.name==undefined){
          Toast("请输入姓名")
          return false
        }
        if(this.sqvalue==""||this.sqvalue==undefined){
          Toast("请选择所属社区")
          return false
        }
        // if(this.value==""||this.value==undefined){
        //   Toast("请选择预约网络点")
        //   return false
        // }
        if(this.phone==""||this.phone==undefined){
          Toast("请输入手机号")
          return false
        }
        if(this.phone.length!=11){
          Toast("手机号格式不正确，请重新输入")
          return false
        }
        if(this.address==""||this.address==undefined){
          Toast("请填写具体地址")
          return false
        }
        if(this.time==""||this.time==undefined){
          Toast("请选择日期")
          return false
        }
        if(this.hour==""||this.hour==undefined){
          Toast("请选择日期")
          return false
        }
        if(this.cjinfo==""||this.cjinfo==undefined){
          Toast("请选择上门理由")
          return false
        }
		if(this.uploader==""||this.uploader==undefined){
		  Toast("请上传证明")
		  return false
		}

        var formdata=new FormData()
        formdata.append("OPENID",this.$store.state.openId)
        formdata.append("USERNAME",this.name)
        formdata.append("PHONE",this.phone)
        formdata.append("SQID",this.sqid)
        formdata.append("SQNAME",this.sqvalue)
        formdata.append("WDID","")
        formdata.append("WDNAME","")
        formdata.append("BEIZHU",this.content)
        formdata.append("YYTIME",this.time+' '+this.hour)
        formdata.append("SHIXIANGID",this.$route.query.sxid)
        formdata.append("ADDRESS",this.address)
        formdata.append("SMREASON",this.cjinfo)
        console.log(this.uploader[0])
        console.log(this.time+' '+this.hour)
        if(this.uploader[0]==''||this.uploader[0]==undefined){
          formdata.append("abc","")
        }
        else{
          formdata.append("abc",this.uploader[0].file)
        }

        this.$http.post(this.$store.state.host+"/interface/smbSave",formdata)
        .then(res=>{
          //发送成功
          console.log(res)
          if(res.body.code==0){
            Toast.success('提交成功');
            this.$router.push("/Yw")
          }
          else{
            Toast.fail(res.body.msg);
          }

          //if()
        },res=>{
           //发送失败
        })
      }
    }
  };
</script>

<style lang="less" scoped>
  /deep/.van-form{
    .van-button--info{
      background-color: #f28033;
      border: 1px solid #f28033;
      border-radius: 5px;
    }
    .van-cell{
      font-size: .26rem;
      }
    .textarea{
      font-size: .26rem;
      padding: 10px 16px;
      color: #646566;
      textarea{
        width: 98%;
        height: 150px;
        border-color: #e5e5e5;
        color: #999999;
        margin-top: 16px;
        padding: 10px 1%;
      }
    }
  }
  /deep/.van-field__control{
    text-align: right;
  }
  .upload{
    padding: 10px 16px;
    font-size: .26rem;
    display: flex;
    p{
      margin-left: .45rem;
      padding-top: 20px;
      color: #646566;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/door.vue